import React, { useState } from 'react'
import { Button, TextField, useTheme } from '@material-ui/core'
import { Container } from '../../components'
import { useVendorInvoice } from '../../contexts/useVendorInvoice'
import Logo from '../../assets/ezos-logo-primary-dark.png'

export type VendorInvoiceCodeGateLayout = 'fullPage' | 'dialog'

interface VendorInvoiceCodeGateProps {
    layout?: VendorInvoiceCodeGateLayout
    /** Called after the code is validated successfully (step is already advanced). */
    onValidated?: () => void
}

export const VendorInvoiceCodeGate = ({
    layout = 'fullPage',
    onValidated,
}: VendorInvoiceCodeGateProps) => {
    const theme = useTheme()
    const [invoiceCodeError, setInvoiceCodeError] = useState(false)
    const vendorInvoiceController = useVendorInvoice()

    const fieldMargin =
        layout === 'fullPage'
            ? theme.spacing(8, 0, 4, 0)
            : theme.spacing(2, 0, 2, 0)

    return (
        <Container
            direction="column"
            style={{
                flex: layout === 'fullPage' ? 1 : undefined,
                height:
                    layout === 'fullPage' ? 'calc(100vh - 104px)' : undefined,
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
            }}
        >
            <img
                src={Logo}
                alt="EZ Turn"
                style={{
                    width: layout === 'fullPage' ? '300px' : '220px',
                    height: layout === 'fullPage' ? '100px' : '74px',
                }}
            />
            <TextField
                variant="outlined"
                placeholder="Invoice Code"
                value={vendorInvoiceController.invoiceCode}
                onChange={(e) => {
                    vendorInvoiceController.setInvoiceCode(e.target.value)
                    setInvoiceCodeError(false)
                }}
                style={{
                    margin: fieldMargin,
                    width: '80%',
                    maxWidth: 400,
                }}
                error={invoiceCodeError}
                helperText={invoiceCodeError ? 'Invalid Code' : ''}
            />
            <Button
                variant="contained"
                style={{
                    backgroundColor: theme.palette.primary.dark,
                    color: 'white',
                    textTransform: 'none',
                    cursor: 'pointer',
                    width: '80%',
                    maxWidth: 400,
                }}
                onClick={() =>
                    vendorInvoiceController
                        .validateCode()
                        .then((valid) => {
                            setInvoiceCodeError(!valid)
                            if (valid) {
                                onValidated?.()
                            }
                        })
                        .catch(() => setInvoiceCodeError(true))
                }
            >
                Submit
            </Button>
        </Container>
    )
}
